import React from 'react'
import { Link } from 'react-router'
import type { WatchlistEntityType } from '../../services/watchlist'
import WatchlistIndicator from './WatchlistIndicator'

interface EntityProfileLinkProps {
  to: string
  entityType: WatchlistEntityType
  entityId: string
  className?: string
  title?: string
  /** When false, caller renders WatchlistIndicator elsewhere (e.g. after a flag). */
  showWatchlist?: boolean
  children: React.ReactNode
}

/**
 * Profile link with an optional inline watchlist marker when the entity is watched.
 */
const EntityProfileLink: React.FC<EntityProfileLinkProps> = ({
  to,
  entityType,
  entityId,
  className = '',
  title,
  showWatchlist = true,
  children,
}) => (
  <span className="inline-flex items-baseline gap-1 min-w-0 max-w-full">
    <Link to={to} className={className} title={title}>
      {children}
    </Link>
    {showWatchlist ? (
      <WatchlistIndicator entityType={entityType} entityId={entityId} />
    ) : null}
  </span>
)

export default EntityProfileLink
